import { TruncatableText } from '@routable/components';
import clsx from 'clsx';
import React from 'react';
import { components } from 'react-select';
import styled from 'styled-components';
import { FlexRow } from 'components/layout';
import {} from './MultiLineOptionForSearchCompanies.types';
const MultiLineOptionAddons = styled.div `
  color: var(--color-neutral-black);
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px;
`;
const MultiLineOptionLabel = styled.div `
  color: var(--color-neutral-black);
  font-family: Inter;
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px;
`;
const MultiLineOptionName = styled.div `
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px;
`;
const MultiLineOptionLegalName = styled.div `
  color: var(--neutrals-grey-60);
  font-feature-settings: 'calt' off;
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
`;
const MultiLineOptionDetails = styled.div `
  color: var(--color-neutral-black);
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px;
`;
export const SearchCompanyOption = ({ data, className, shouldUseNewPartnershipSelect, ...rest }) => {
    const { details, leftAddons, rightAddons } = data;
    const { dataFullStory } = Object(rest.selectProps);
    const isCreateNewOption = Boolean(data.__isNew__);
    const name = data.name || data.companyName;
    const legalName = data.partner?.name;
    const numberOfAddons = (rightAddons?.props?.children || []).filter(Boolean).length;
    const content = (React.createElement(FlexRow, { className: "align-items--center", stackOnMobile: false },
        leftAddons && React.createElement(MultiLineOptionAddons, { className: "pr-4" }, leftAddons),
        React.createElement("div", { className: "flex-col flex-1 gap-2 w-full" },
            isCreateNewOption ? (React.createElement(MultiLineOptionLabel, { className: "search-company-option__label", "data-fullstory": dataFullStory }, rest.label)) : (React.createElement(MultiLineOptionName, { className: "search-company-option__label", "data-fullstory": dataFullStory }, name)),
            legalName && (React.createElement(MultiLineOptionLegalName, { className: "flex w-full gap-[6px] !text-grey-70 search-company-option__details" },
                React.createElement("span", { style: {
                        maxWidth: shouldUseNewPartnershipSelect && rightAddons
                            ? `calc(100% - 12px - ${numberOfAddons} * 56px)`
                            : '100%',
                    } },
                    React.createElement(TruncatableText, { text: `Legal name: ${legalName}` })),
                shouldUseNewPartnershipSelect && rightAddons)),
            React.createElement(MultiLineOptionDetails, { className: "search-company-option__details" }, details)),
        !shouldUseNewPartnershipSelect && React.createElement(MultiLineOptionAddons, { className: "pl-4" }, rightAddons)));
    return shouldUseNewPartnershipSelect ? (React.createElement("div", { ...rest, className: clsx('multi-line-option w-full', className, {
            '!text-grey-50 opacity-50 pointer-events-none': rest.disabled,
        }), "data-fullstory": dataFullStory }, content)) : (React.createElement(components.Option, { ...rest, className: clsx('multi-line-option w-full', className), data: data, "data-fullstory": dataFullStory }, content));
};
